import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static get targets() {
    return [ 'display' ]
  }

  connect() {
    this.scheduleRefresh()
    this.refresh()
  }
  disconnect() {
    this.cancelRefresh()
  }

  scheduleRefresh() {
    this.timer = setInterval(this.refresh.bind(this), 1000)
  }
  cancelRefresh() {
    clearInterval(this.timer)
    this.timer = null
  }

  refresh() {
    let totalSeconds = this.duration();
    let seconds = totalSeconds % 60;
    let minutes = Math.floor(totalSeconds / 60) % 60;
    let hours = Math.floor(totalSeconds / 3600);
    
    this.output(this.pad(hours) + ':' + this.pad(minutes) + ':' + this.pad(seconds));
  }

  pad(number) {
    if (number <= 99) {
      number = ('0' + number).slice(-2)
    }
    return number
  }

  output(content) {
    this.displayTarget.innerHTML = content
  }

  // total seconds on clock
  duration() {
    return this.delta() + this.offset()
  }

  // seconds elapsed since start (dynamic)
  delta() {
    if (this.start() === null) { return 0; }

    return Math.floor((Date.now() - this.start()) / 1000)
  }

  start() {
    if (!this.data.has('start')) { return null }

    return new Date(this.data.get('start'))
  }

  // seconds offset (static)
  offset() {
    if (!this.data.has('offset')) { return 0; }

    return parseInt(this.data.get('offset') || '0');
  }
}
